module.exports = __webpack_public_path__ + "img/logo.10dfc23c.svg";